var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c("div", { staticClass: "table-header" }, [
      _c("div", { staticClass: "table-header-cell date" }, [
        _vm._v(" " + _vm._s(_vm.$t("Date")) + " "),
      ]),
      _c("div", { staticClass: "table-header-cell txn" }, [
        _vm._v(" " + _vm._s(_vm.$t("Txn")) + " "),
      ]),
      _c("div", { staticClass: "table-header-cell bet" }, [
        _vm._v(" " + _vm._s(_vm.$t("Total")) + " "),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "table-body" },
      [
        _vm._l(_vm.ticketsDisplay, function (ticket, index) {
          return _c(
            "div",
            { key: index },
            [
              _c(
                "div",
                {
                  staticClass: "total-general table-row",
                  class: { even: (index + 1) % 2 === 0 },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.collapseToggle(index)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "table-cell date" }, [
                    _c("span", [_vm._v(_vm._s(ticket.date))]),
                  ]),
                  _c("div", { staticClass: "txn" }, [
                    _vm._v(_vm._s(ticket.txn || "-")),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "table-cell bet",
                      class: {
                        win: ticket.total > 0,
                        lose: ticket.total < 0,
                        selected: _vm.isRowUnCollapse(index),
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            `${_vm.currencySymbol} ${_vm.formatAmount(
                              ticket.total
                            )}`
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]
              ),
              _c("Transition", [
                _vm.isRowUnCollapse(index)
                  ? _c(
                      "div",
                      {
                        staticClass: "total-details table-row",
                        class: { even: (index + 1) % 2 === 0 },
                      },
                      [
                        _c("div", { staticClass: "table-cell jackpot" }, [
                          _c("span", { staticClass: "total-header" }, [
                            _vm._v(_vm._s(_vm.$t("Jackpot"))),
                          ]),
                          _c(
                            "span",
                            {
                              class: {
                                win: ticket.jackpot > 0,
                                lose: ticket.jackpot < 0,
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  Number(ticket.jackpot)
                                    ? `${_vm.currencySymbol} ${_vm.formatAmount(
                                        ticket.jackpot
                                      )}`
                                    : "-"
                                )
                              ),
                            ]
                          ),
                        ]),
                        _c("div", { staticClass: "table-cell ante" }, [
                          _c("span", { staticClass: "total-header" }, [
                            _vm._v(" " + _vm._s(_vm.$t("Ante"))),
                          ]),
                          _c("span", { class: { lose: Number(ticket.ante) } }, [
                            _vm._v(
                              _vm._s(
                                Number(ticket.ante)
                                  ? `${_vm.currencySymbol} -${_vm.formatAmount(
                                      ticket.ante
                                    )}`
                                  : "-"
                              )
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "table-cell commission" }, [
                          _c("span", { staticClass: "total-header" }, [
                            _vm._v(_vm._s(_vm.$t("Commission")) + " "),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(
                                Number(ticket.commission)
                                  ? `${_vm.currencySymbol} ${_vm.formatAmount(
                                      ticket.commission
                                    )}`
                                  : "-"
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "table-cell wl-total" }, [
                          _c("span", { staticClass: "total-header" }, [
                            _vm._v("W/L"),
                          ]),
                          _c(
                            "span",
                            {
                              class: {
                                win: ticket.wl > 0,
                                lose: ticket.wl < 0,
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  Number(ticket.wl)
                                    ? `${_vm.currencySymbol} ${_vm.formatAmount(
                                        ticket.wl
                                      )}`
                                    : "-"
                                )
                              ),
                            ]
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]),
            ],
            1
          )
        }),
        _c(
          "div",
          {
            staticClass: "table-row total-amount",
            class: { even: (_vm.ticketsDisplay.length + 1) % 2 === 0 },
          },
          [
            _c("div", { staticClass: "table-cell" }, [
              _vm._v(" " + _vm._s(_vm.$t("Total")) + " "),
            ]),
            _c(
              "div",
              {
                staticClass: "table-cell",
                class: {
                  win: _vm.overallTotal > 0,
                  lose: _vm.overallTotal < 0,
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      `${_vm.currencySymbol} ${_vm.formatAmount(
                        _vm.overallTotal
                      )}`
                    ) +
                    " "
                ),
              ]
            ),
          ]
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }